import { useConfiguratorContext } from "@grandvisionhq/configurator";
import { useIntl, useFeatureToggles, useSelector } from "@grandvisionhq/state";
import { useRxGlassesConfiguratorContext } from "../../context/context/RxGlassesConfiguratorContext.js";
import "../../state/state/actions.js";
import "../../state/add-to-cart/state/add-to-cart/selectors.js";
import "../../state/bundles/state/bundles/selectors.js";
import "../../state/bundles/state/bundles/reducer.js";
import { hasVisitedStepLensPackage, hasVisitedStepAddOn, getSelectedFrame, getSelectedLensType, getSelectedPackage, getSelectedAddOn, getBundlePrice, getBundleMinimumSupplement } from "../../state/configurator/state/configurator/selectors.js";
import "../../state/configurator/state/configurator/reducer.js";
import "../../state/products/state/products/selectors.js";
import "../../state/products/state/products/reducer.js";
const useConfigurationSummary = ({ location }) => {
  const { id } = useRxGlassesConfiguratorContext();
  const { isOnLastStep } = useConfiguratorContext();
  const { getLabel } = useIntl();
  const { isConfiguratorRxPriceFromEnabled } = useFeatureToggles();
  const hasVisitedStepLensPackage$1 = useSelector(
    (s) => hasVisitedStepLensPackage(s, { id })
  );
  const hasVisitedStepAddOn$1 = useSelector(
    (s) => hasVisitedStepAddOn(s, { id })
  );
  const frame = useSelector(getSelectedFrame);
  const lensType = useSelector(getSelectedLensType);
  const lensPackage = useSelector(getSelectedPackage);
  const addOn = useSelector(getSelectedAddOn);
  const bundlePrice = useSelector(
    (s) => getBundlePrice(s, { id })
  );
  const minimumBundleSupplement = useSelector(
    (s) => getBundleMinimumSupplement(s, { id })
  );
  let totalPricePrefix;
  if (isConfiguratorRxPriceFromEnabled && !isOnLastStep) {
    const labelKey = location === "desktop" ? "products.glasses.configurator.price.fromLong" : "products.glasses.configurator.price.fromShort";
    totalPricePrefix = getLabel(labelKey, { hideLabelKey: true });
  }
  return {
    frame,
    lensType,
    lensPackage,
    addOn,
    bundlePrice,
    hasVisitedStepAddOn: hasVisitedStepAddOn$1,
    hasVisitedStepLensPackage: hasVisitedStepLensPackage$1,
    totalPricePrefix,
    minimumBundleSupplement
  };
};
export {
  useConfigurationSummary as default
};
//# sourceMappingURL=use-configuration-summary.js.map
